module.exports = [
    {
        moduleName: "leads",
        access :{
            module_access: false,
            add: false,
            viewOnly: false,
            viewAll: false,
            modifyOnly: false,
            modifyAll: false,
            fullAccess: false,
            delete: false,
            import: false,
            export: false
        }
    },
    {
        moduleName: "contacts",
        access :{
            module_access: false,
            add: false,
            viewOnly: false,
            viewAll: false,
            modifyOnly: false,
            modifyAll: false,
            fullAccess: false,
            delete: false,
            import: false,
            export: false
        }
    },
    {
        moduleName: "advisors",
        access :{
            module_access: false,
            add: false,
            viewOnly: false,
            viewAll: false,
            modifyOnly: false,
            modifyAll: false,
            fullAccess: false,
            delete: false,
            import: false,
            export: false
        }
    },
    {
        moduleName: "deals",
        access :{
            module_access: false,
            add: false,
            viewOnly: false,
            viewAll: false,
            modifyOnly: false,
            modifyAll: false,
            fullAccess: false,
            delete: false,
            import: false,
            export: false
        }
    },
    {
        moduleName: "policies",
        access :{
            module_access: false,
            add: false,
            viewOnly: false,
            viewAll: false,
            modifyOnly: false,
            modifyAll: false,
            fullAccess: false,
            delete: false,
            import: false,
            export: false
        }
    },
    {
        moduleName: "insurances partner",
        access :{
            module_access: false,
            add: false,
            viewOnly: false,
            viewAll: false,
            modifyOnly: false,
            modifyAll: false,
            fullAccess: false,
            delete: false,
            import: false,
            export: false
        }
    },
    {
        moduleName: "offerings",
        access :{
            module_access: false,
            add: false,
            viewOnly: false,
            viewAll: false,
            modifyOnly: false,
            modifyAll: false,
            fullAccess: false,
            delete: false,
            import: false,
            export: false
        }
    },
    {
        moduleName: "locations",
        access :{
            module_access: false,
            add: false,
            viewOnly: false,
            viewAll: false,
            modifyOnly: false,
            modifyAll: false,
            fullAccess: false,
            delete: false,
            import: false,
            export: false
        }
    },
    {
        moduleName: "users",
        access :{
            module_access: false,
            add: false,
            viewOnly: false,
            viewAll: false,
            modifyOnly: false,
            modifyAll: false,
            fullAccess: false,
            delete: false,
            import: false,
            export: false
        }
    },
    {
        moduleName: "refferels",
        access :{
            module_access: false,
            add: false,
            viewOnly: false,
            viewAll: false,
            modifyOnly: false,
            modifyAll: false,
            fullAccess: false,
            delete: false,
            import: false,
            export: false
        }
    },
    {
        moduleName: "roles",
        access :{
            module_access: false,
            add: false,
            viewOnly: false,
            viewAll: false,
            modifyOnly: false,
            modifyAll: false,
            fullAccess: false,
            delete: false,
            import: false,
            export: false
        }
    },
    {
        moduleName: "permissions",
        access :{
            module_access: false,
            add: false,
            viewOnly: false,
            viewAll: false,
            modifyOnly: false,
            modifyAll: false,
            fullAccess: false,
            delete: false,
            import: false,
            export: false
        }
    }
]